// @flow
import type {Element} from 'react'
import React, {Component} from 'react'
import {compose, filter, isEmpty, not, prop} from 'ramda'
import classNames from 'classnames'

import ChangeTitle from 'components/proposals/Part/ui/Summary/ChangeTitle'
import DiffItem from './DiffItem'
import Value from '../../Value'

const onlyChanged = filter(compose(not, prop('isUnchanged')))

/* eslint react/no-array-index-key: 0 */

type Props = $ReadOnly<{
  changeKey: string,
  list: $ReadOnlyArray<Value>,
  title: string,
  className?: string,
}>

class DiffList extends Component<Props> {
  get className(): string {
    return classNames(
      'proposal-summary-diff-list',
      `test-field-${this.changeKey}`,
      this.props.className,
    )
  }

  get changeKey(): string {
    return this.props.changeKey
  }

  render(): null | Element<"div"> {
    const changed: Value[] = onlyChanged(this.props.list)

    if (isEmpty(changed))
      return null

    return (
      <div className={this.className} key={this.changeKey}>
        <ChangeTitle title={this.props.title} />
        <div className="proposal-summary-diff-list__items">
          {changed.map((value, index) => (
            <div key={index} className="proposal-summary-diff-list__item">
              <DiffItem value={value} />
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default DiffList
